import React from "react";
import { Link as GatsbyLink } from "gatsby";

function isExternalLink(link) {
  return /^http/.test(link);
}

const actionLinks = ["mailto:", "tel:"];

export const Link = ({ to, children, ...props }) => {
  return isExternalLink(to) || !to ? (
    <a href={to} target="_blank" rel="noreferrer" {...props}>
      {children}
    </a>
  ) : String(to).startsWith("mailto:" || "tel:") ? (
    <a href={to} {...props}>
      {children}
    </a>
  ) : (
    <GatsbyLink to={to} {...props}>
      {children}
    </GatsbyLink>
  );
};
